var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon for toaster"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006401"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4210",
    cx: 30,
    cy: 30,
    r: 29,
    stroke: "#B42318",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9092 34.6808L28.6039 17.5469H31.675L31.3697 34.6808H28.9092ZM28.7343 38.8653C29.13 38.4696 29.5913 38.2784 30.1457 38.2784C30.6798 38.2784 31.1339 38.467 31.5322 38.8653L31.5352 38.8683C31.9291 39.2555 32.123 39.7075 32.1314 40.2503C32.1235 40.6163 32.0276 40.9454 31.8439 41.2471L31.8423 41.2499C31.6608 41.5524 31.4214 41.7917 31.1189 41.9732C30.8261 42.1489 30.5052 42.2376 30.1457 42.2376C29.5893 42.2376 29.1275 42.0489 28.7327 41.6616C28.3396 41.2677 28.1533 40.8093 28.16 40.2578L28.1598 40.2457C28.1532 39.7038 28.3386 39.2544 28.7313 38.8683L28.7343 38.8653Z",
    fill: "#B42318"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnableIcon);
export default __webpack_public_path__ + "static/media/UnableIcon.961dc6c2e2d8aaba8d258f09bbc758af.svg";
export { ForwardRef as ReactComponent };